import React from "react";
import { Icon, IconProps } from "@/shared/ui/Icon";
import { Badge, BadgeProps } from "@/shared/ui/Badge";
import { cn } from "@/shared/utils/shadcn";

export interface IconBadgeProps extends IconProps {
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  hasOpacity?: boolean;
  children?: React.ReactNode;
}

const IconBadge: React.FC<IconBadgeProps> = (props) => {
  const {
    className,
    color,
    hasOpacity = true,
    size = "sm",
    children,
    ...rest
  } = props;

  const iconColor = hasOpacity ? color : "white";
  const bgColor = hasOpacity ? `${color}-light` : color;

  return (
    <Badge className={className} bg={bgColor as BadgeProps["bg"]} size={size}>
      <Icon color={iconColor} size={size} {...rest} />
      {children}
    </Badge>
  );
};

export default IconBadge;
